const { getOffsetTop } = window.BAO.Utils

class ScaleImage extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        transition: transform 0.5s ease;
      }
      :host([active]) {
        transition: transform 0.1s ease;
      }
    `
  }

  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()

    window.setTimeout(() => {
      this.setAttribute('active', '')
    }, 500)
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.scaleMedia()
  }

  scaleMedia () {
    if (!this.offsetHeight) return

    const maxScale = this.hasAttribute('data-scale-small')
      ? window.BAO.MediaBreakpoints.isSm
        ? 1.075
        : 1.2
      : window.BAO.MediaBreakpoints.isSm
        ? 1.15
        : 1.2

    const imageStartsScaling = getOffsetTop(this) - window.innerHeight
    const imageEndsScaling = imageStartsScaling + window.innerHeight * 0.75
    const totalScrollAmount = imageEndsScaling - imageStartsScaling

    if (this.lastKnownY < imageStartsScaling) {
      this.style.transform = `scale(${maxScale})`

      return
    }

    if (this.lastKnownY > imageEndsScaling) {
      this.style.transform = `none`

      return
    }

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - imageStartsScaling) / totalScrollAmount
    const scaleAmount =
      maxScale - (maxScale - 1) * scrollYAsAPercentageOfJourney

    this.style.transform = `scale(${scaleAmount})`
  }
}

if (!customElements.get('scale-image')) {
  customElements.define('scale-image', ScaleImage)
}
